// @ts-strict-ignore
import {Component, ElementRef, EventEmitter, Injector, Output, ViewChild} from "@angular/core";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {EventEmitterService} from "@event-emitter";
import {Translations} from "@translations";
import {AudioDevice, IAudioClientService, AudioClientMode, AudioClientFactory} from "@services";

@UntilDestroy()
@Component({
	selector: "sim-client-audio-device",
	templateUrl: "./client-audio-device.component.html",
	styleUrls: ["./client-audio-device.component.scss", "../../toolbar-menu.component.scss"],
	providers: [EventEmitterService, AudioClientFactory],
	standalone: false,
})
export class ClientAudioDeviceComponent {
	T = Translations;

	@Output() readonly closeComponent = new EventEmitter<void>();

	@Output() mode: AudioClientMode = null;
	@Output() isClientDeviceUsed: boolean = false;

	public audioClient: IAudioClientService;

	@ViewChild("levelMeter") canvasLevelMeter: ElementRef<HTMLCanvasElement>;

	constructor(private _injector: Injector) {
		this.closeComponent.pipe(untilDestroyed(this)).subscribe(async () => await this.audioClient.stopVisualizer());

		try {
			let factory = this._injector.get(AudioClientFactory);
			factory?.create().then(async (data) => {
				if (data) {
					this.isClientDeviceUsed = true;
					this.audioClient = data.service;
					this.mode = data.mode;
				}
			});
		} catch (e) {
			console.error(e);
		}
	}

	public async setAudioDevice(audioDevice: AudioDevice) {
		return await this.audioClient.setAudioDevice(audioDevice);
	}

	public async openComponent() {
		await this.audioClient.reloadAudioDevices();
		await this.audioClient.startVisualizer(this.canvasLevelMeter.nativeElement);
	}
}
